module.exports = __webpack_public_path__ + "01c8060544bc82f3c6316e5ff0d6cee0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/band-egyptian.png
// module id = 2643
// module chunks = 0